import { env } from "@car/env/web";
import { phoneNumberClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

function getServerUrl(url: string) {
  // SAFETY: process exists only in server runtimes; optional chain guards absence
  const processEnv = (
    globalThis as {
      process?: { env?: Record<string, string | undefined> };
    }
  ).process?.env;
  if (!("window" in globalThis) && processEnv?.SERVER_URL) {
    return processEnv.SERVER_URL.endsWith("/")
      ? processEnv.SERVER_URL.slice(0, -1)
      : processEnv.SERVER_URL;
  }

  const normalized = url.endsWith("/") ? url.slice(0, -1) : url;

  if (!normalized.startsWith("/")) {
    return normalized;
  }

  if ("window" in globalThis) {
    return `${window.location.origin}${normalized}`;
  }

  const vercelUrl =
    processEnv?.VERCEL_ENV === "production"
      ? (processEnv?.VERCEL_PROJECT_PRODUCTION_URL ?? processEnv?.VERCEL_URL)
      : (processEnv?.VERCEL_URL ?? processEnv?.VERCEL_PROJECT_PRODUCTION_URL);
  if (vercelUrl) {
    const origin = vercelUrl.startsWith("http") ? vercelUrl : `https://${vercelUrl}`;
    return `${origin}${normalized}`;
  }

  return `http://localhost:3000${normalized}`;
}
export const authClient = createAuthClient({
  // better-auth derives its route-matching base from this URL's path, so the
  // public auth path must equal the server-side mount; the site's own instance (customerAuth),
  // so a staff session of the panel in the same browser stays apart
  baseURL: new URL("/api/customer-auth", getServerUrl(env.VITE_SERVER_URL)).toString(),
  plugins: [phoneNumberClient()],
});

type SessionUser = { role?: string | null; phoneNumber?: string | null };

/** CUSTOMER_ROLE of @car/auth/roles; the web app does not depend on the auth package */
const CUSTOMER_ROLE = "customer";

/** The customer panel is for phone-OTP customers only; a staff account is turned away */
export const isCustomerUser = (user: SessionUser | null | undefined) =>
  user?.role === CUSTOMER_ROLE;
